import {
  EDIT_TOPIC_MODAL_I18N_KEYS
} from '../../../../../features/topics/components/constants/i18n/EditTopicModali18nConstants';

export const EDIT_TOPIC_MODAL_I18N_EN = {
  [EDIT_TOPIC_MODAL_I18N_KEYS.topic_details_title]:       "Topic Details",
  [EDIT_TOPIC_MODAL_I18N_KEYS.close_button_text]:         "CLOSE",
  [EDIT_TOPIC_MODAL_I18N_KEYS.upload_files_title]:        "Upload Files",
  [EDIT_TOPIC_MODAL_I18N_KEYS.no_uploaded_files_message]: "This topic currently has no uploaded files."
};


// WEBPACK FOOTER //
// ./src/locales/en/features/topics/components/edit_topic_modal.i18n.en.js